
import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";


  
export default function MonthResourceCard({data, accumulated}) {

    const bodyValues = [
        {
            title: 'Meta',
            quantity: 'MetaCantidad',
            price: 'MetaPrecio',
            parcial: 'MetaParcial',
        },
        {
            title: 'Prog. Período',
            quantity: 'ProgramadoCantidad',
            price: 'ProgramadoPrecio',
            parcial: 'ProgramadoParcial',
        },
        {
            title: 'Val. Período',
            quantity: 'ValorizadoCantidad',
            price: 'ValorizadoPrecio',
            parcial: 'ValorizadoParcial',
        },
        {
            title: 'Real',
            quantity: 'RealCantidad',
            price: 'RealPrecio',
            parcial: 'RealParcial',
        },
        {
            title: 'Diferencia',
            quantity: 'DiferenciaCantidad',
            price: 'DiferenciaPrecio',
            parcial: 'DiferenciaParcial',
        },
    ]
    const bodyValuesAccumulated = [
        {
            title: 'Meta',
            quantity: 'MetaCantidad',
            price: 'MetaPrecio',
            parcial: 'MetaParcial',
        },
        {
            title: 'Prog. Acum',
            quantity: 'ProgramadoCantidad',
            price: 'ProgramadoPrecio',
            parcial: 'ProgramadoParcial',
        },
        {
            title: 'Val. Acum',
            quantity: 'ValorizadoCantidad',
            price: 'ValorizadoPrecio',
            parcial: 'ValorizadoParcial',
        },
        {
            title: 'Real',
            quantity: 'RealCantidad',
            price: 'RealPrecio',
            parcial: 'RealParcial',
        },
        {
            title: 'Diferencia',
            quantity: 'DiferenciaCantidad',
            price: 'DiferenciaPrecio',
            parcial: 'DiferenciaParcial',
        },
    ]
  
    return (
        <Box sx={{ maxWidth: 600, margin: "auto", p: 2 }}>
            <Paper elevation={3} style={{padding: '1rem'}}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Grid item>
                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
                            {data.DesInsumo}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Grid item>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                            ({data.CodInsumo})
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" sx={{ fontWeight: "bold", color: "#333" }}>
                            Unidad: {data.Unidad}
                        </Typography>
                    </Grid>
                </Grid>
    
                <TableContainer >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                            <TableCell sx={{ fontWeight: "bold", color: "#666", border: "none" }}>
                                
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: "bold", color: "#666", border: "none" }}>
                                Cantidad
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: "bold", color: "#666", border: "none" }}>
                                Precio (S/.)
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: "bold", color: "#666", border: "none" }}>
                                Parcial
                            </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(accumulated === 0 ? bodyValues : bodyValuesAccumulated).map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{
                                            fontWeight: row.meta === "Diferencia" ? "bold" : "normal",
                                            color: "#333",
                                            border: "none",
                                            py: 1,
                                        }}
                                    >
                                        {row.title}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            color: "#333",
                                            border: "none",
                                            py: 1,
                                        }}
                                    >
                                        {data[row.quantity] ? (data[row.quantity]).toFixed(2) : '-'}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            color: "#333",
                                            border: "none",
                                            py: 1,
                                        }}
                                    >
                                        {data[row.price] ? (data[row.price]).toFixed(2) : '-'}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            color: row.parcial.includes("-") ? "#d32f2f" : "#333",
                                            fontWeight: row.meta === "Diferencia" ? "bold" : "normal",
                                            border: "none",
                                            py: 1,
                                        }}
                                    >
                                        {data[row.parcial] ? (data[row.parcial]).toFixed(2) : '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    )
  }
  